import { render, staticRenderFns } from "./approvedList.vue?vue&type=template&id=61bdb48f&scoped=true"
import script from "./approvedList.vue?vue&type=script&lang=js"
export * from "./approvedList.vue?vue&type=script&lang=js"
import style0 from "./approvedList.vue?vue&type=style&index=0&id=61bdb48f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bdb48f",
  null
  
)

export default component.exports